(() => {
  const mounted=new WeakSet();
  const setup=()=>document.querySelectorAll('[data-studio-menu]').forEach(menu=>{
    if(mounted.has(menu))return;mounted.add(menu);
    const summary=menu.querySelector('summary');
    summary.setAttribute('aria-expanded',String(menu.open));
    menu.addEventListener('toggle',()=>summary.setAttribute('aria-expanded',String(menu.open)));
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){menu.open=false;summary.focus();}});
    document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});
    menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.open=false;summary.focus({preventScroll:true});}));
  });
  setup();document.addEventListener('shopify:section:load',setup);
})();
